import { render } from "./AutoRefresh.vue?vue&type=template&id=66707bb0&scoped=true"
import script from "./AutoRefresh.vue?vue&type=script&lang=js"
export * from "./AutoRefresh.vue?vue&type=script&lang=js"

import "./AutoRefresh.vue?vue&type=style&index=0&id=66707bb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66707bb0"]])

export default __exports__